import React from "react";
import { Link } from "react-router-dom";
import { useResources } from "../hooks/resources";

export default function() {
  let [recipes, loading] = useResources("recipe");

  return (
    <div>
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-bold leading-none">Recipes</h1>

        <Link to="/recipes/new" className="py-2 px-1 text-blue-500 font-medium">
          New
        </Link>
      </div>

      {loading ? (
        <p className="text-center mt-8 text-lg font-bold text-gray-500 uppercase">
          Loading...
        </p>
      ) : (
        <div className="sm:flex sm:flex-wrap sm:-mx-4">
          {recipes
            .sort((a, b) => (a.name > b.name ? 1 : -1))
            .map(recipe => (
              <div className="mt-10 sm:w-1/2 sm:px-4 md:w-1/3" key={recipe.id}>
                <Link
                  to={`/recipes/${recipe.id}`}
                  className="inline-block w-full no-underline"
                >
                  <div className="rounded-lg shadow-lg overflow-hidden">
                    <div className="aspect-ratio">
                      <div
                        className="bg-cover bg-center"
                        style={{
                          backgroundImage: `url(${recipe.imageUrl})`
                        }}
                      />
                    </div>

                    <div className="p-4 bg-white">
                      <p className="text-lg font-bold leading-snug">
                        {recipe.name}
                      </p>
                    </div>
                  </div>
                </Link>
              </div>
            ))}
        </div>
      )}
    </div>
  );
}
